import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './Tooltip.scss';

const Tooltip = ({ delayHide, children, tooltipText, place, }) => {
  return (
    <div className="tooltip-container">
      <span className="tooltip-label" data-tip={tooltipText} data-for={tooltipText}>{children}</span>
      <ReactTooltip
        id={tooltipText}
        className="default-tooltip"
        delayHide={delayHide}
        effect="solid"
        type="info"
        place={place}
      />
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltipText: PropTypes.string.isRequired,
  place: PropTypes.string.isRequired,
  delayHide: PropTypes.number,
};

Tooltip.defaultProps = {
  delayHide: null,
};

export default Tooltip;
